module.exports = __webpack_public_path__ + "img/doctor-kit.451709d0.png";